'use strict';

/*@ngInject*/
module.exports = function publicUsersService($http) {

	this.passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\s\S]{8,}$/;

	this.registerUser = function (user) {
		return $http.post('publicUsers/registerUser', user);
	};

	this.updatePublicUser = function (user) {
		return $http.post('publicUsers/updatePublicUser', user);
	};

	this.restorePassword = function (email) {
		return $http.get('publicUsers/restorePassword/' + email);
	};

	this.setNewPassword = function (userData) {
		return $http.post('publicUsers/setNewPassword/', userData);
	};

	this.getBookmarks = function () {
		return $http.get('bookmarks/getBookmarks');
	};

	this.updateBookmark = function (objectType, objectId) {
		return $http.post('bookmarks/updateBookmark/' + objectType + '/' + objectId);
	};

	this.userHasBookmark = function (objectId, objectType) {
		return $http.get('bookmarks/userHasBookmark/' + objectId + '/' + objectType);
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/services/public-users.service.js
 **/